import { Typography } from '@mui/material';
import { API } from '../../../api/api';
import { URLS } from '../../../api/urls';
import { Modal } from '../../../components/Modal/Modal';
import { ALERT_TEXT } from '../../../constants/content';
import { useAlert } from '../../../context/Alert.context';
import {
  ServiceInfo,
  ServiceInfoFromBack,
} from '../../../types/serviceInfo.types';
import { ServiceInfoForm } from '../components/ServiceInfoForm';
import { Tip } from './components/Tip';
import styles from './styles.module.css';
import { parseServiceInfoListToArray } from '../utils/parseServiceInfo';

interface CreateServiceModalProps {
  open: boolean;
  onClose: () => void;
  selectedGadgetId: string;
  updateAfterCreating: (serviceInfo: ServiceInfoFromBack) => void;
}

export const CreateServiceInfoModal = ({
  onClose,
  open,
  selectedGadgetId,
  updateAfterCreating,
}: CreateServiceModalProps) => {
  const { showAlert } = useAlert();

  const createService = (serviceFromForm: ServiceInfo) => {
    const service = parseServiceInfoListToArray(serviceFromForm);
    const formData = new FormData();
    formData.append('fileInfo', service.fileInfo as File);
    formData.append('gadgetId', selectedGadgetId);
    formData.append('icon', service.icon);

    formData.append('titleEn', service.titleEn);
    formData.append('titlePl', service.titlePl);
    formData.append('titleUk', service.titleUk);
    formData.append('titleRu', service.titleRu);

    formData.append('shortTitleEn', service.shortTitleEn);
    formData.append('shortTitlePl', service.shortTitlePl);
    formData.append('shortTitleUk', service.shortTitleUk);
    formData.append('shortTitleRu', service.shortTitleRu);

    formData.append('subTitleEn', service.subTitleEn);
    formData.append('subTitlePl', service.subTitlePl);
    formData.append('subTitleUk', service.subTitleUk);
    formData.append('subTitleRu', service.subTitleRu);

    formData.append('metaDescriptionEn', service.metaDescriptionEn);
    formData.append('metaDescriptionPl', service.metaDescriptionPl);
    formData.append('metaDescriptionUk', service.metaDescriptionUk);
    formData.append('metaDescriptionRu', service.metaDescriptionRu);

    formData.append('titleSeoEn', service.titleSeoEn || '');
    formData.append('titleSeoPl', service.titleSeoPl || '');
    formData.append('titleSeoUk', service.titleSeoUk || '');
    formData.append('titleSeoRu', service.titleSeoRu || '');
    formData.append('isPopular', service.isPopular ? 'true' : 'false');
    formData.append('menuPriority', String(service.menuPriority || 0));

    const infoEn = JSON.stringify(service.infoEn);
    const infoRu = JSON.stringify(service.infoRu);
    const infoUk = JSON.stringify(service.infoUk);
    const infoPl = JSON.stringify(service.infoPl);

    formData.append('infoEn', infoEn);
    formData.append('infoRu', infoRu);
    formData.append('infoUk', infoUk);
    formData.append('infoPl', infoPl);

    API.post(URLS.SERVICE_INFO, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(({ data }) => {
        onClose();
        updateAfterCreating(data);
        showAlert({
          message: ALERT_TEXT.INFO_CREATED_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }));
  };

  return (
    <Modal
      shouldPreventModal
      title={
        <div className={styles.modalHeader}>
          <Typography variant="h6">Create service info</Typography>
          <Tip />
        </div>
      }
      open={open}
      onClose={onClose}
    >
      <ServiceInfoForm
        serviceInfo={null}
        onCancel={onClose}
        createService={createService}
      />
    </Modal>
  );
};
